import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpEventType, HttpResponse } from '@angular/common/http';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { UploadJsonService } from '../../service/upload-json.service';
import { UploadJsonModel } from '../../models/commissionsummary/upload-json.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import * as XLSX from 'xlsx';
import { FormControl, NgForm } from '@angular/forms';
import { CommSummaryModel } from 'src/app/models/commissionsummary/commsummary.model';
import { CommissionSummaryService } from 'src/app/service/commission-summary.service';
import { map, startWith } from 'rxjs/operators';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { GlobalService } from 'src/app/service/global.service';
import { UploadJsonHeadersModel } from 'src/app/models/commissionsummary/upload-json-headers.model';
import { ReportsService } from 'src/app/service/reports.service';

@Component({
  selector: 'app-upload-json',
  templateUrl: './upload-json.component.html',
  styleUrls: ['./upload-json.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class UploadJsonComponent implements OnInit {

  selectedFiles: FileList;
  currentFile: File;
  message = '';

  public dataSource = new MatTableDataSource<UploadJsonModel>();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;

  public displayedColumns = ['page_name', 'grid_name', 'order', 'sql', 'commPlanId', 'salesChannel', 'kpiId', 'update', 'view', 'download'];
  public expandedElement: null;
  public showLoading: boolean;
  public commSummaryModel = new CommSummaryModel();

  private subscriptions: Subscription[] = [];
  public refreshing: boolean;
  public pageResponse: UploadJsonModel[] = [];

  public fileInfos: Observable<any>;
  public sc: string;
  public commPlanId: number;
  public commplans: UploadJsonModel[];

  public uploadJsonModel = new UploadJsonModel();
  public uploadJsonModelEdit = new UploadJsonModel();
  public uploadJsonModelEdit1 = new UploadJsonModel();
  public uploadJsonModelClone = new UploadJsonModel();

  public kpisData: UploadJsonModel[] = [];
  public comPlanData: UploadJsonModel[] = [];
  public reportTypesData: UploadJsonModel[] = [];
  public jsonModels: UploadJsonModel[] = [];

  dropDownsData: CommSummaryModel[] = [];
  headersGroupData: UploadJsonModel[] = [];
  headersGroupDataEdit: UploadJsonModel[] = [];
  filteredSalesChannelsData: CommSummaryModel[] = [];
  filteredCommPlansData: CommSummaryModel[] = [];
  filteredCommPlansDataClone: CommSummaryModel[] = [];
  filteredCommPlansDataEdit: CommSummaryModel[] = [];
  public salesChannels: UploadJsonModel[] = [];

  filteredSalesChannelValues: Observable<CommSummaryModel[]> | undefined;
  controlSc = new FormControl();
  filteredCommissionPlans: Observable<CommSummaryModel[]> | undefined;
  controlCp = new FormControl();
  filteredKpiValues: Observable<UploadJsonModel[]> | undefined;
  controlKpi = new FormControl();

  filteredSalesChannelValuesEdit: Observable<CommSummaryModel[]> | undefined;
  controlScEdit = new FormControl();
  filteredCommissionPlansEdit: Observable<CommSummaryModel[]> | undefined;
  controlCpEdit = new FormControl();
  filteredKpiValuesEdit: Observable<UploadJsonModel[]> | undefined;
  controlKpiEdit = new FormControl();

  filteredSalesChannelValuesClone: Observable<CommSummaryModel[]> | undefined;
  controlScClone = new FormControl();
  filteredCommissionPlansClone: Observable<CommSummaryModel[]> | undefined;
  controlCpClone = new FormControl();


  columnsExcelData: any;
  dataForExcel = [];
  ordersTableExcelHeaderColumns: TableColumn[];

  uploadJsonData: UploadJsonModel[] = [];
  excelUploadJsonData: UploadJsonModel[] = [];

  // GRID FRAMEWORK
  ordersTableColumns1: TableColumn[];
  ordersTableColumns2: TableColumn[];
  ordersTableColumns3: TableColumn[];

  columnsData: any;
  actions: any;
  actionButtons: any;

  isAccessDisabled: boolean = false;

  public headersEditModels: UploadJsonHeadersModel[] = [];
  public buttonsEditModels: UploadJsonHeadersModel[] = [];
  public uploadJsonHeadersModel = new UploadJsonHeadersModel();

  jid: number = 0;

  constructor(private globalService: GlobalService, private httpService: HttpClient, private router: Router, private uploadJsonService: UploadJsonService,
    public ete: ExportExcelService, private authGaurdService: AuthGaurdService, private notificationService: NotificationService, private commissionSummaryService: CommissionSummaryService,
    private reportsService: ReportsService) { }

  ngOnInit(): void {
    //Get Permissions
    this.isAccessDisabled = this.globalService._permissionCheck('upload-json');

    if (this.isAccessDisabled === true) {
      this.controlScEdit.disable();
      this.controlCpEdit.disable();
      this.controlKpiEdit.disable();
      this.controlScClone.disable();
      this.controlCpClone.disable();
    }

    this.initializeColumns();
    this.getDropDownsData();
    this.getReportTypes();
    this.getKpis();
    this.getComPlans();
    this.initializeExcelHeaders();
    this.getJsonsList('a', 0);

    this.uploadJsonModelEdit.created_by = "";
    this.uploadJsonModelEdit.created_dt = new Date();
    this.jsonModels.push(this.uploadJsonModelEdit);
  }

  public getJsonsList(sc: string, commPlanId: number): void {
    console.log("Inside getJsonsList()");
    this.subscriptions.push(
      this.uploadJsonService.getJsonsList(sc, commPlanId).subscribe(
        (response: UploadJsonModel[]) => {
          this.uploadJsonData = response;
          this.excelUploadJsonData = JSON.parse(JSON.stringify(response));
          this.syncEditModelFromList();
        },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public getReportTypes(): void {
    this.subscriptions.push(
      this.uploadJsonService.getReportTypes().subscribe(
        (response: UploadJsonModel[]) => {
          this.reportTypesData = response;
        },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public getKpis(): void {
    this.subscriptions.push(
      this.uploadJsonService.getKpis().subscribe(
        (response: UploadJsonModel[]) => {
          this.kpisData = response;
          //this.filterKpis();
        },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public getComPlans(): void {
    this.subscriptions.push(
      this.uploadJsonService.getComPlans().subscribe(
        (response: UploadJsonModel[]) => {
          this.comPlanData = response;
          //this.filterKpis();
        },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public getSalesChannels(): void {
    this.refreshing = true;
    this.subscriptions.push(
      this.uploadJsonService.getSalesChannels().subscribe(
        (response: UploadJsonModel[]) => {
          this.salesChannels = response;
          //console.log(this.salesChannels);
          this.refreshing = false;
        }, (errorResponse: HttpErrorResponse) => {
          this.refreshing = false;
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.uploadJson;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  exportExcel() {
    for (let js of this.excelUploadJsonData) {
      delete js.id;
      delete js.status;
      delete js.created_by;
      delete js.created_dt;
      delete js.updated_dt;
      delete js.updated_by;
      delete js.kpiId;
      delete js.comment;
      delete js.commPlanId;
    }
    this.dataForExcel = [];
    let reportData = null;
    this.excelUploadJsonData.forEach((row: any) => {
      console.log("obj === " + Object.values(row));
      this.dataForExcel.push(Object.values(row));
    })
     reportData = {
      title: 'UploadJson',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.ete.exportExcel(reportData);
  }

  uploadJSON() {
    console.log(this.uploadJsonModel.kpiId);
    console.log(this.uploadJsonModel.commPlanId);

    if (this.uploadJsonModel.kpiId === null) {
      this.uploadJsonModel.kpiId = 0;
    }
    this.uploadJsonService.uploadJSON(this.currentFile, this.uploadJsonModel.gridName, this.uploadJsonModel.sql, this.uploadJsonModel.pageName,
      this.uploadJsonModel.colSort, this.uploadJsonModel.kpiId, this.uploadJsonModel.report_type, this.uploadJsonModel.description, this.uploadJsonModel.commPlanId,this.uploadJsonModel.salesChannel).subscribe(
        event => {
          //eventForm.reset();
          this.invalidateReportsSqlCache();
          this.getSalesChannels();
          this.getJsonsList('a', 0);
          this.clickButton('new-trans-close');
          this.notificationService.sendNotification(NotificationType.SUCCESS, 'Uploaded Successfully');
        },
        err => {
          this.notificationService.sendNotification(NotificationType.ERROR, 'Something went wrong!');
          this.message = 'Something went wrong!';
        });
  }

  updateCommUi() {
    console.log("updateCommUi() called");
    let vkpiid = "";
    let vcomplan = "";
    for (let val of this.jsonModels) {
      vkpiid = vkpiid + val.kpiId + ",";
      vcomplan = vcomplan + val.commPlanId + ",";
    }
   
    this.uploadJsonService.updateJSONWithoutFile(this.uploadJsonModelEdit.gridName, this.uploadJsonModelEdit.sql,
      this.uploadJsonModelEdit.pageName, this.uploadJsonModelEdit.colSort, vcomplan,
      this.uploadJsonModelEdit.salesChannel, vkpiid, this.uploadJsonModelEdit.id).subscribe(
        res => {
          console.log("updateCommUi() called: "+JSON.stringify(res));
          this.invalidateReportsSqlCache();
          this.getSalesChannels();
          this.getJsonsList('a', 0);
          this.clickButton('new-trans-update-close');
          this.notificationService.sendNotification(NotificationType.SUCCESS, 'Uploaded Successfully');
        },
        err => {
          this.notificationService.sendNotification(NotificationType.ERROR, 'Failed To Update!');
          this.message = 'Failed To Update!';
        });
   
  }

  public getCommPlanAndKpis(id: number) {
    console.log(id);
    this.jid = id;
    this.uploadJsonService.getCommPlanAndKpis(id).subscribe(
      (response: UploadJsonModel[]) => {
        this.jsonModels = response;
        console.log(this.headersEditModels);
        if (this.jsonModels.length === 0) {
          this.uploadJsonModelEdit.created_by = "";
          this.uploadJsonModelEdit.created_dt = new Date();
          this.jsonModels.push(this.uploadJsonModelEdit);
        }
      },
      (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }
  public getHeaders(id: number) {
    console.log(id);
    this.jid = id;
    this.subscriptions.push(
      this.uploadJsonService.fetchHeaders(id).subscribe(
        (response: UploadJsonHeadersModel[]) => {
          this.headersEditModels = response;
          console.log(this.headersEditModels);
          if (this.headersEditModels.length === 0) {
            this.uploadJsonHeadersModel.created_by = "";
            this.uploadJsonHeadersModel.created_dt = new Date();
            this.headersEditModels.push(this.uploadJsonHeadersModel);
          }
          this.getButtons(id);
        },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  updateHeaders() {
    this.headersEditModels[0].jsonsqlid = this.jid;
    console.log(this.headersEditModels);
    this.uploadJsonService.updateHeaders(this.headersEditModels)
      .subscribe((data: UploadJsonHeadersModel[]) => {
        this.getJsonsList('a', 0);
        this.notificationService.sendNotification(NotificationType.SUCCESS, 'Updated Successfully');
      },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
  }

  public getButtons(id: number) {
    console.log(id);
    this.jid = id;
    this.subscriptions.push(
      this.uploadJsonService.fetchButtons(id).subscribe(
        (response: UploadJsonHeadersModel[]) => {
          this.buttonsEditModels = response;
          console.log(this.buttonsEditModels);
          if (this.buttonsEditModels.length === 0) {
            this.uploadJsonHeadersModel.created_by = "";
            this.uploadJsonHeadersModel.created_dt = new Date();
            this.buttonsEditModels.push(this.uploadJsonHeadersModel);
          }
        },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  updateButtons() {
    this.buttonsEditModels[0].jsonsqlid = this.jid;
    console.log(this.buttonsEditModels);
    this.uploadJsonService.updateButtons(this.buttonsEditModels)
      .subscribe((data: UploadJsonHeadersModel[]) => {
        this.getJsonsList('a', 0);
        this.notificationService.sendNotification(NotificationType.SUCCESS, 'Updated Successfully');
      },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
  }

  cloneData() {
    //alert(this.sc + "-" + this.uploadJsonModelEdit.commPlanId);
    //alert(this.uploadJsonModelClone.salesChannel + "-" + this.uploadJsonModelClone.commPlanId);

    if (this.uploadJsonModelClone.salesChannel === null || this.uploadJsonModelClone.commPlanId === null) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select both fields');
    } else if (this.sc === this.uploadJsonModelClone.salesChannel && this.uploadJsonModelEdit.commPlanId === this.uploadJsonModelClone.commPlanId) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Already exists. Choose different');
    } else {
      this.uploadJsonService.cloneData(this.sc, this.uploadJsonModelEdit.commPlanId, this.uploadJsonModelClone.commPlanId, this.uploadJsonModelClone.salesChannel).subscribe(
        event => {
          this.getSalesChannels();
          this.clickButton('clone-close');
          this.notificationService.sendNotification(NotificationType.SUCCESS, 'Cloned Successfully');
        },
        err => {
          this.notificationService.sendNotification(NotificationType.ERROR, 'Failed!');
        });
    }
  }



  filterSalesChannelsClone() {
    this.filteredSalesChannelValuesClone = this.controlScClone.valueChanges.pipe(
      startWith(''),
      map(value => this._filterSCClone(value))
    );
  }
  private _filterSCClone(value: string) {
    const filterValue = this._normalizeValue(value);
    return this.filteredSalesChannelsData.filter(item => this._normalizeValue(item.salesChannel).includes(filterValue));
  }
  public getSelectedSalesChannelsClone(val: any) {
    var cpdata = "";
    if (val === 0 || val === "" || val === null || val === undefined) {
      cpdata = "";
    } else {
      cpdata = this.filteredSalesChannelsData.find(item => item.salesChannel === val).salesChannel;
    }
    return cpdata;
  }
  public getSelectedScClone(event: any) {
    const filterValue = this._normalizeValue(event.option.value);
    this.filteredCommPlansData = this.dropDownsData.filter(item => this._normalizeValue(item.salesChannel).startsWith(filterValue));
    this.filteredCommPlansData = this.filteredCommPlansData.filter((v, i) => this.filteredCommPlansData.findIndex(item => item.commPlan == v.commPlan) === i);
    this.filteredCommPlansData = this.filteredCommPlansData.sort((a, b) => (a.commPlan < b.commPlan) ? -1 : 1);
    //console.log("this.filteredCommPlansData = " + this.filteredCommPlansData);
    this.filterCommissionPlansClone();
  }

  filterCommissionPlansClone() {
    this.filteredCommissionPlansClone = this.controlCpClone.valueChanges.pipe(
      startWith(''),
      map(value => this._filterCpClone(value))
    );
  }
  private _filterCpClone(value: string) {
    const filterValue = this._normalizeValue(value);
    return this.filteredCommPlansData.filter(item => this._normalizeValue(item.commPlan).includes(filterValue));
  }
  public getSelectedComPlansClone(val: any) {
    //alert(val);
    var cpdata = "";
    if (val === 0 || val === "" || val === null || val === undefined) {
      cpdata = "";
    } else {
      //console.log(this.filteredCommPlansData);
      this.filteredCommPlansDataClone = this.dropDownsData.filter(item => this._normalizeValue(item.commPlanId.toString()).startsWith(val));
      this.filteredCommPlansDataClone = this.filteredCommPlansDataClone.filter((v, i) => this.filteredCommPlansDataClone.findIndex(item => item.commPlan == v.commPlan) === i);
      this.filteredCommPlansDataClone = this.filteredCommPlansDataClone.sort((a, b) => (a.commPlan < b.commPlan) ? -1 : 1);

      cpdata = this.filteredCommPlansDataClone.find(item => item.commPlanId === val).commPlan;
      //alert(cpdata);
    }
    return cpdata;
  }


  filterSalesChannelsEdit() {
    this.filteredSalesChannelValuesEdit = this.controlScEdit.valueChanges.pipe(
      startWith(''),
      map(value => this._filterSCEdit(value))
    );
  }
  private _filterSCEdit(value: string) {
    const filterValue = this._normalizeValue(value);
    return this.filteredSalesChannelsData.filter(item => this._normalizeValue(item.salesChannel).includes(filterValue));
  }
  public getSelectedSalesChannelsEdit(val: any) {
    var cpdata = "";
    if (val === 0 || val === "" || val === null || val === undefined) {
      cpdata = "";
    } else {
      cpdata = this.filteredSalesChannelsData.find(item => item.salesChannel === val).salesChannel;
    }
    return cpdata;
  }
  public getSelectedScEdit(event: any) {
    const filterValue = this._normalizeValue(event.option.value);
    this.filteredCommPlansData = this.dropDownsData.filter(item => this._normalizeValue(item.salesChannel).startsWith(filterValue));
    this.filteredCommPlansData = this.filteredCommPlansData.filter((v, i) => this.filteredCommPlansData.findIndex(item => item.commPlan == v.commPlan) === i);
    this.filteredCommPlansData = this.filteredCommPlansData.sort((a, b) => (a.commPlan < b.commPlan) ? -1 : 1);
    //console.log("this.filteredCommPlansData = " + this.filteredCommPlansData);
    this.filterCommissionPlansEdit();
  }

  filterCommissionPlansEdit() {
    this.filteredCommissionPlansEdit = this.controlCpEdit.valueChanges.pipe(
      startWith(''),
      map(value => this._filterCpEdit(value))
    );
  }
  private _filterCpEdit(value: string) {
    const filterValue = this._normalizeValue(value);
    return this.filteredCommPlansData.filter(item => this._normalizeValue(item.commPlan).includes(filterValue));
  }
  public getSelectedComPlansEdit(val: any) {
    //alert(val);
    var cpdata = "";
    if (val === 0 || val === "" || val === null || val === undefined) {
      cpdata = "";
    } else {
      //console.log(this.filteredCommPlansData);
      this.filteredCommPlansDataEdit = this.dropDownsData.filter(item => this._normalizeValue(item.commPlanId.toString()).startsWith(val));
      this.filteredCommPlansDataEdit = this.filteredCommPlansDataEdit.filter((v, i) => this.filteredCommPlansDataEdit.findIndex(item => item.commPlan == v.commPlan) === i);
      this.filteredCommPlansDataEdit = this.filteredCommPlansDataEdit.sort((a, b) => (a.commPlan < b.commPlan) ? -1 : 1);

      cpdata = this.filteredCommPlansDataEdit.find(item => item.commPlanId === val).commPlan;
      //alert(cpdata);
    }
    return cpdata;
  }

  filterKpisEdit() {
    this.filteredKpiValuesEdit = this.controlKpiEdit.valueChanges.pipe(
      startWith(''),
      map(value => this._filterKpiEdit(value))
    );
  }

  private _filterKpiEdit(value: string) {
    const filterValue = this._normalizeValue(value);
    return this.kpisData.filter(item => this._normalizeValue(item.kpiName).includes(filterValue));
  }
  public getSelectedKpisEdit(val: any) {
    var cpdata = "";
    if (val === 0 || val === "" || val === null || val === undefined) {
      cpdata = "";
    } else {
      cpdata = this.kpisData.find(item => item.kpiId === val).kpiName;
    }
    return cpdata;
  }



  filterKpis() {
    this.filteredKpiValues = this.controlKpi.valueChanges.pipe(
      startWith(''),
      map(value => this._filterKpi(value))
    );
  }

  private _filterKpi(value: string) {
    const filterValue = this._normalizeValue(value);
    return this.kpisData.filter(item => this._normalizeValue(item.kpiName).includes(filterValue));
  }
  public getSelectedKpis(val: any) {
    var cpdata = "";
    if (val === 0 || val === "" || val === null || val === undefined) {
      cpdata = "";
    } else {
      cpdata = this.kpisData.find(item => item.kpiId === val).kpiName;
    }
    return cpdata;
  }

  public getDropDownsData(): void {
    this.subscriptions.push(
      this.commissionSummaryService.getDropDownsData().subscribe(
        (response: CommSummaryModel[]) => {
          this.dropDownsData = response;
          //console.log("this.dropDownsData = " + JSON.stringify(this.dropDownsData));
          this.filteredSalesChannelsData = this.dropDownsData.filter((v, i) => this.dropDownsData.findIndex(item => item.salesChannel != "" && item.salesChannel == v.salesChannel) === i);
          this.filteredSalesChannelsData = this.filteredSalesChannelsData.sort((a, b) => (a.salesChannel < b.salesChannel) ? -1 : 1);
        //console.log("this.filteredSalesChannelsData = "+JSON.stringify(this.filteredSalesChannelsData));
          this.filterSalesChannels();
        },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  filterSalesChannels() {
    this.filteredSalesChannelValues = this.controlSc.valueChanges.pipe(
      startWith(''),
      map(value => this._filterSC(value))
    );
  }
  private _filterSC(value: string) {
    const filterValue = this._normalizeValue(value);
    return this.filteredSalesChannelsData.filter(item => this._normalizeValue(item.salesChannel).includes(filterValue));
  }
  public getSelectedSalesChannels(val: any) {
    var cpdata = "";
    if (val === 0 || val === "" || val === null || val === undefined) {
      cpdata = "";
    } else {
      cpdata = this.filteredSalesChannelsData.find(item => item.salesChannel === val).salesChannel;
    }
    return cpdata;
  }
  public getSelectedSc(event: any) {
    const filterValue = this._normalizeValue(event.option.value);
    this.filteredCommPlansData = this.dropDownsData.filter(item => this._normalizeValue(item.salesChannel).startsWith(filterValue));
    this.filteredCommPlansData = this.filteredCommPlansData.filter((v, i) => this.filteredCommPlansData.findIndex(item => item.commPlan == v.commPlan) === i);
    this.filteredCommPlansData = this.filteredCommPlansData.sort((a, b) => (a.commPlan < b.commPlan) ? -1 : 1);
    //console.log("this.filteredCommPlansData = " + this.filteredCommPlansData);
    this.filterCommissionPlans();
  }

  filterCommissionPlans() {
    this.filteredCommissionPlans = this.controlCp.valueChanges.pipe(
      startWith(''),
      map(value => this._filterCp(value))
    );
  }
  private _filterCp(value: string) {
    const filterValue = this._normalizeValue(value);
    return this.filteredCommPlansData.filter(item => this._normalizeValue(item.commPlan).includes(filterValue));
  }
  public getSelectedComPlans(val: any) {
    var cpdata = "";
    if (val === 0 || val === "" || val === null || val === undefined) {
      cpdata = "";
    } else {
      cpdata = this.filteredCommPlansData.find(item => item.commPlanId === val).commPlan;
    }
    return cpdata;
  }

  private _normalizeValue(value: string): string {
    if (value)
      return value.toString().toLowerCase().replace(/\s/g, '');
    else
      return '';
  }



  showJson(json: string, page_name: string) {
    //console.log("comm_doc value ==== "+atob(comm_doc));
    //console.log("comm_doc encode value ==== "+encodeURI(comm_doc));
    let pdfWindow = window.open("");
    pdfWindow.document.write("<html<head><title>" + page_name + "</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>");
    pdfWindow.document.write("<body><embed width='100%' height='100%' src='data:application/json;base64, " + encodeURI(json) + "#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>");
  }

  downloadJson(json: string, page_name: string) {
    const linkSource = 'data:application/json;base64,' + json;
    const downloadLink = document.createElement("a");
    const fileName = page_name;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }


  selectFile(event) {
    this.selectedFiles = undefined;
    this.currentFile = undefined;
    this.selectedFiles = event.target.files;
    this.currentFile = this.selectedFiles.item(0);
  }



  onFileChange(evt: any) {
    const target: DataTransfer = <DataTransfer>(evt.target);

    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    console.log('evt=== ', evt);
  }

  public redirect(url: string) {
    this.router.navigate(['/' + url]);
  }

  ExportTOExcel() {
    this.ete.exportFromHtmlTable(this.table.nativeElement, 'TranslateData');
  }

  public saveNewTrans(): void {
    this.clickButton('new-trans-save');
  }
  public cloneNewTrans(): void {
    this.clickButton('new-trans-clone');
  }
  public updateNewTrans(): void {
    this.clickButton('new-trans-update');
  }
  public getSalesChannelName(salesChannel: string) {
    this.sc = salesChannel;
    this.getCommPlans(this.sc);
  }
  public getCommPlans(sc: string) {
    this.uploadJsonService.getCommPlans(sc)
      .subscribe((res: any) => {
        this.commplans = res;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }
  public getCommPlanId(commPlanId: number) {
    this.commPlanId = commPlanId;
    console.log(this.commPlanId);
    console.log(this.sc);
    this.getJsonsList(this.sc, this.commPlanId);
  }

  public onEditJson(jsonModel: UploadJsonModel): void {
    this.uploadJsonModelEdit = JSON.parse(JSON.stringify(jsonModel));
    this.getHeaders(jsonModel.id);
    this.getCommPlanAndKpis(jsonModel.id);
    this.clickButton('Edit');
  }

  public cloneCommPlan(jsonModel: UploadJsonModel): void {
    this.uploadJsonModelEdit = JSON.parse(JSON.stringify(jsonModel));
    this.clickButton('Clone');
  }

  private syncEditModelFromList(): void {
    const editId = this.uploadJsonModelEdit?.id;
    if (editId == null) {
      return;
    }
    const refreshed = this.uploadJsonData.find(item => item.id === editId);
    if (refreshed) {
      this.uploadJsonModelEdit = JSON.parse(JSON.stringify(refreshed));
    }
  }

  private invalidateReportsSqlCache(): void {
    this.reportsService.clearReportsSqlCache().subscribe({
      error: () => {
        // Backend also invalidates on save; ignore if manual clear endpoint is unavailable.
      }
    });
  }



  addNewHeaderEditRow(kpiForm: NgForm) {
    const headerObj = new UploadJsonHeadersModel();
    headerObj.name = this.uploadJsonHeadersModel.name;
    headerObj.datakey = this.uploadJsonHeadersModel.datakey;
    headerObj.pagenav = this.uploadJsonHeadersModel.pagenav;
    headerObj.colspancnt = this.uploadJsonHeadersModel.colspancnt;
    headerObj.colorder = this.uploadJsonHeadersModel.colorder;
    headerObj.position = this.uploadJsonHeadersModel.position;
    headerObj.istotalview = this.uploadJsonHeadersModel.istotalview;
    headerObj.ishyperlinkview = this.uploadJsonHeadersModel.ishyperlinkview;

    this.headersEditModels.push(headerObj);
    //console.log("add kpiEditModels = " + JSON.stringify(this.kpiEditModels));
  }
  public removeHeaderEditRow(index: any) {
    if (this.headersEditModels.length > 1) {
      if (this.headersEditModels[index].name != null) {
        this.removeHeaderEditFilterData(index);
      }
      else {
        this.removeHeaderEditFilterData(index);
        this.headersEditModels.splice(index, 1);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }
  }
  private removeHeaderEditFilterData(i: any) {
    if (this.headersEditModels.length > 0) {
      const compos = this.headersEditModels[i].name;
      this.headersEditModels.forEach((value: any, index: any) => {
        if (value.name == compos)
          this.headersEditModels.splice(index, 1);
      })
    }
  }


  // buttons
  addNewButtonsEditRow(kpiForm: NgForm) {
    const headerObj = new UploadJsonHeadersModel();
    headerObj.name = this.uploadJsonHeadersModel.name;
    headerObj.pagenav = this.uploadJsonHeadersModel.pagenav;

    this.buttonsEditModels.push(headerObj);
    //console.log("add kpiEditModels = " + JSON.stringify(this.kpiEditModels));
  }
  public removeButtonsEditRow(index: any) {
    if (this.buttonsEditModels.length > 1) {
      if (this.buttonsEditModels[index].name != null) {
        this.removeButtonsEditFilterData(index);
      }
      else {
        this.removeButtonsEditFilterData(index);
        this.buttonsEditModels.splice(index, 1);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }
  }
  private removeButtonsEditFilterData(i: any) {
    if (this.buttonsEditModels.length > 0) {
      const compos = this.buttonsEditModels[i].name;
      this.buttonsEditModels.forEach((value: any, index: any) => {
        if (value.name == compos)
          this.buttonsEditModels.splice(index, 1);
      })
    }
  }

  hideRemainingLabels(id: number): boolean {
    if (id === 0)
      return true;
    else
      return false;
  }

  addNewRow(missingForm: NgForm) {
    const kpiObj = new UploadJsonModel();
    kpiObj.kpiId = this.uploadJsonModelEdit1.kpiId;
    //kpiObj.comm_plan_id = this.uploadJsonModelEdit1.comm_plan_id;
    this.jsonModels.push(kpiObj);
    console.log(this.jsonModels);
  }

  public removeRow(index: any) {
    if (this.jsonModels.length > 1) {
      if (this.jsonModels[index].kpiId != null) {
        this.removeFilterData(index);
      } else {
        this.removeFilterData(index);
        //this.kpiModels.splice(index, 1);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }
  }

  private removeFilterData(i: any) {

    if (this.jsonModels.length > 0) {
      const compos = this.jsonModels[i].kpiId;
      this.jsonModels.forEach((value: any, index: any) => {
        if (value.kpiId == compos)
          this.jsonModels.splice(index, 1);
      })
    }
    console.log(this.jsonModels);
  }


  // GRID FRAMEWORK
  innerRowAction1(row: any) {
    console.log(" row ....", row.row.salesChannel, "=== val  ", row.value);

    if (row.value === 'View') {
      this.getSalesChannelName(row.row.salesChannel);
    }

    if (row.value === 'Update') {
      //this.downloadPdf(row.row.comm_doc_str,row.row.doc_name)
      console.log(row.row);
      this.onEditJson(row.row);

    }

  }
  innerRowAction2(row: any) {
    console.log(" row ....", row.row.commPlanId, "=== val  ", row.value);

    if (row.value === 'View') {
      this.getCommPlanId(row.row.commPlanId);
    }

    if (row.value === 'Clone') {
      this.cloneCommPlan(row.row);
    }

  }
  innerRowAction3(row: any) {
    console.log(" row ....", row.row.id, "=== val  ", row.value);
    if (row.value === 'Update') {
      //this.downloadPdf(row.row.comm_doc_str,row.row.doc_name)
      console.log(row.row);
      this.onEditJson(row.row);

    }
    if (row.value === 'Display') {
      //this.downloadPdf(row.row.comm_doc_str,row.row.doc_name)
      this.showJson(row.row.jsonStr, row.row.pageName);
    }
    if (row.value === 'JSON') {
      this.downloadJson(row.row.jsonStr, row.row.pageName);
    }

  }

  actionOnButton(action: any) {
    if (action === "Add SQL") {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.clickButton(action);
      }
    }
  }

  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }


  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns1 = this.columnsData.uploadJsonSalesChannel;
        this.ordersTableColumns2 = this.columnsData.uploadJsonCommPlans;
        this.ordersTableColumns3 = this.columnsData.uploadJson;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
    this.actions = [
      {
        name: 'Update',
        dataKey: 'far fa-edit success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      },
      {
        name: 'Clone',
        dataKey: 'fas fa-clone success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-danger'
      }
    ]

    this.actionButtons = [
      {
        name: 'Add SQL',
        class: 'btn btn-success btn-xs'
      }
    ]
  }
}